<template>
  <v-app>
    <v-container fluid class="fill-height px-0 pt-0 pb-0">
      <v-row
        no-gutters
        class="auth-container flex-column flex-md-column-reverse flex-lg-row mx-0 mx-lg-15 px-lg-2"
      >
        <v-col cols="12" md="6" class="auth-img d-flex justify-center">
          <img :src="bgImgPath" alt="auth image">
        </v-col>
        <v-col cols="12" md="6" align-self="center">
          <router-view />
        </v-col>
      </v-row>

      <v-row
        v-if="showSteps"
        class="steps-wrapper justify-space-between d-flex auth-container mx-0 mx-lg-15 px-lg-2"
      >
        <v-col cols="1"></v-col>
        <v-col cols="3">
          <q-r-step
            :step="1"
            :subtitle="$t('authLogin.step1SubTitle')"
            :description="$t('authLogin.step1SubDescription')"
          />
        </v-col>
        <v-col cols="3">
          <q-r-step
            :step="2"
            :subtitle="$t('authLogin.step2SubTitle')"
            :description="$t('authLogin.step2SubDescription')"
          />
        </v-col>
        <v-col cols="3">
          <q-r-step
            :step="3"
            :subtitle="$t('authLogin.step3SubTitle')"
            :description="$t('authLogin.step3SubDescription')"
          />
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { isDesktopView } from '@/layouts/mobile-view'
import QRStep from '@/components/auth/QRStep'

export default {
  name: 'AuthPage',
  components: {
    QRStep,
  },
  data() {
    return {
      bgImgPath: '',
      isDesktopView: true,
    }
  },
  computed: {
    showSteps() {
      return this.$route.name === 'qrCodePage'
    },
  },
  watch: {
    $route() {
      this.setBgImg()
    },
  },
  mounted() {
    this.setBgImg()
    this.checkWindowWidth()
    window.addEventListener('resize', this.checkWindowWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkWindowWidth)
  },
  methods: {
    setBgImg() {
      const currentPath = this.$route.name
      this.bgImgPath = process.env.BASE_URL + `media/bg/${currentPath}.png`
    },
    checkWindowWidth() {
      this.isDesktopView = isDesktopView()
    },
  },
}
</script>
<style lang="scss" scoped>
.steps-wrapper {
  padding-bottom: 100px;
}
.auth-img img {
  width: 100%;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    width: 50%;
  }
}
</style>
